









































import {Component, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import {DialogForm, FormOverlay} from '@/components/bwaff';
import temporaryPasswordDialogApi, { TemporaryPasswordDialogApi } from './temporary-password-dialog-api';
import moment from 'moment';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class TemporaryPasswordDialog extends Form {
  @Prop({default:'DD MMMM YYYY HH:mm'}) 
  format: string;

  temporaryPasswordDialogApi: TemporaryPasswordDialogApi = temporaryPasswordDialogApi;

  active: boolean = false;
  edit: boolean = true;
  form: any = {};
  time: any = {};

  mounted() {
    this.$store.commit('loading', true);
    this.temporaryPasswordDialogApi.get().then((res:any)=>{
      this.form = res;
      this.form.expireAt =  moment(moment.utc(this.form.expireAt).toDate()).local().format(this.format);
      this.$store.commit('loading', false);
      this.active = true;
    });

  }

  close() {
    this.active = false;
    this.$emit('close');
  }

}
